
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import mutations from './mutations'
import actions from './actions'

const state = {
  confirmOrderAddr: {}, // 生成订单的地址
  confirmOrderCartlist: [], // 生成订单的商品列表
  confirmOrderCycount: 0, // 生成订单商品总个数
  confirmOrderTotal: 0, // 生成订单总费用
  searchGoodsList: [], // 搜索商品列表
  isShowQrCode: false // 是否显示二维码弹框
}

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : [],
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js